<template>
    <div>
        <!-- BradCrumb header Start-->
        <section class="inner-header-bg">
            <div class="container">
                <div class="section-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 justify-content-center align-self-center pb-2">
                                <div class="breadcrumb-content">
                                    <div class="title-section">
                                        <h1 class="title text-center text-white">Connecting Your Remote Sites & Control Center</h1>
                                    </div>
                                    <div class="breadcrumb-nav">
                                        <ul class="breadcrumb-link text-center list-unstyled mb-0">
                                            <li class="text-white"><router-link to="/">Home</router-link></li>
                                            <li class="text-white active">Oilfield & Remote Site IT</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- BradCrumb header End -->
        <!-- Start Content -->
        <section class="section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <h2>Reliable IT for Demanding Field Operations</h2>
                        <p>The Eagle Ford and other industrial environments in South Texas present unique IT challenges: harsh conditions, limited power, and unreliable connectivity. Cynexsol specializes in designing and deploying rugged, dependable IT and communication solutions that keep your remote operations connected and secure.</p>
                        
                        <h2>Our Industrial & Remote Site Services</h2>
                        
                        <h3>Remote Site Connectivity Solutions</h3>
                        <p>A stable data link is non-negotiable. We engineer connectivity solutions using the right technology for the location:</p>
                        <ul>
                            <li>Point-to-Point/Multipoint Wireless for high-speed links.</li>
                            <li>Industrial-grade Cellular (LTE/5G) for primary or backup connectivity.</li>
                            <li>Satellite (VSAT) for the most remote locations.</li>
                        </ul>

                        <h3>SCADA & OT Network Integration</h3>
                        <p>We build secure, high-availability networks to transport your critical operational data. Our expertise ensures that your SCADA, telemetry, and HMI data flows reliably from the field to your control center, with proper network isolation to protect your sensitive operational technology (OT).</p>

                        <h3>Rugged & Off-Grid Power Solutions</h3>
                        <p>We can design and build self-sufficient communication enclosures for sites with unreliable or non-existent grid power, utilizing solar panels and battery arrays to keep your equipment online.</p>

                        <h2>Real-World Scenario: Connecting a Remote Production Facility</h2>
                        <p>An energy company needed to establish a reliable data connection to a new production facility in a remote area of Dimmit County to monitor tank levels and flow rates.</p>
                        <p><strong>Our Solution:</strong> We deployed a hybrid connectivity solution using a point-to-point wireless link from a nearby facility, backed up by an industrial cellular router for redundancy. The system was connected to a solar power station we designed, providing uninterrupted data flow to their central SCADA system.</p>

                        <router-link to="/camera-nvr-networks">We also secure industrial facilities with our Camera & NVR Networks.</router-link>
                    </div>
                </div>
            </div>
        </section>
        <!-- End Content -->
    </div>
</template>
<script>
    export default {
        name: 'OilfieldIT'
    }
</script>
